export var InventoryViewMode;
(function (InventoryViewMode) {
    InventoryViewMode["CRITICAL"] = "CRITICAL";
    InventoryViewMode["EARLY"] = "EARLY";
})(InventoryViewMode || (InventoryViewMode = {}));
//# sourceMappingURL=inventory.types.js.map